import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as AuthActions from '../actions/Auth';
import * as RequestParamActions from '../actions/RequestParam';
import Header from '../components/common/Header';

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    header: state.header,
    request_param: state.request_param,
    moffAPI: state.moffAPI,
    moffCheck: state.moffCheck,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    requestParamActions: bindActionCreators(RequestParamActions, dispatch),
 };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Header as any) as any);



// WEBPACK FOOTER //
// ./src/containers/Header.tsx